module.exports = __webpack_public_path__ + "img/ic_happytable_datastorage.cbb40d91.png";